<div style="display: flex;flex-direction: column;flex: 1; overflow: auto;">
    <div mat-dialog-title>
        <span *ngIf="announcements.length > 0">New Announcements</span> 
        <span *ngIf="announcements.length === 0">Daily Announcements </span>
    </div>
    
    <mat-dialog-content>
        <div style="display: flex; flex-direction: column; flex: 1" *ngIf="announcements.length > 0">
            <div *ngIf="announcements.length > 0">
                <ng-container *ngFor="let tableDatum of tableData; let i = index">
                    <ng-container *ngIf="showTableFlags[i]">
                    <h1 role="heading" class="sectionHeader" translate>{{sectionNames[i]}}</h1>
                    <announcement-table [tableData]="tableDatum" [classAnnouncements]="i === 2"></announcement-table>
                   </ng-container>
                  </ng-container>
                  <ng-container *ngFor="let school of schoolName">
                    <ng-container>
                      <h1 role="heading" class="sectionHeader" translate>{{school}}</h1>
                      <announcement-table [tableData]="siteAnnouncement | newAnnouncementsModalFilter:school" [classAnnouncements]="false"></announcement-table>
                     </ng-container>
                  </ng-container>
            </div>
        </div>
        <div *ngIf="siteDailyAnnouncement.length > 0 && announcements.length === 0">
            <ng-container *ngFor="let tableDatadaily of tableDailyData; let i = index">
                <ng-container *ngIf="showTableDailyFlags[i]">
                    <h1 role="heading" class="sectionHeader" translate>{{sectionNames[i]}}</h1>
                    <announcement-table [tableData]="tableDatadaily" [classAnnouncements]="i === 2"></announcement-table>
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let school of schoolNameDaily">
                <ng-container>
                    <h1 role="heading" class="sectionHeader" translate>{{school}}</h1>
                    <announcement-table [tableData]="siteDailyAnnouncementTable | newAnnouncementsModalFilter:school"  [classAnnouncements]="false"></announcement-table>
                </ng-container>
            </ng-container> 
        </div>
    </mat-dialog-content>    

    <mat-dialog-actions>
        <div class="flex-footer-left">
            <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
        </div>
        <div class="flex-footer-right">
            <tyl-button id="allAnnouncementsButton" image="next arrow.png" *ngIf="announcements.length > 0" label="All Announcements" (clickEvent)="allAnnouncementsClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
</div>